module.exports = __webpack_public_path__ + "img/slogn.2457e936.svg";